<template>
  <transition name="fade-in-up">
    <router-view></router-view>
  </transition>
</template>

<style lang="scss" scoped>
@import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>

<script>
import { SET_MENU } from '@/core/services/store/modules/menu.module';
import { SET_PERMISSION } from '@/core/services/store/modules/permission.module';
import { SideBar } from '@/core/config/menu/sideBar';
import ApiService from '@/core/services/api.service';
export default {
  components: {},
  mounted() {
    this.$store.dispatch(SET_MENU, SideBar.BILL);
  },
  created() {
    this.getPermissions();
  },
  methods: {
    getPermissions() {
      ApiService.get('permissions/').then((reponse) => {
        const permissions = reponse.data?.data || [];
        this.$store.dispatch(SET_PERMISSION, permissions);
      });
    },
  },
};
</script>
